import { render, staticRenderFns } from "./FirmwaresPermitidos.vue?vue&type=template&id=2de29814&"
import script from "./FirmwaresPermitidos.vue?vue&type=script&lang=js&"
export * from "./FirmwaresPermitidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports